import React from 'react';

export default class ThemeItem extends React.Component {
  handleChange(e) {
    const target = e.target
    this.setState({checked: target.checked})
    this.props.handleFilterChange(target.checked, target.value)
  }
  
  checked() {
    return ($.inArray(this.props.theme.id, this.props.checked_themes) !== -1)
  }

  labelClass() {
    if(this.checked()) {
      return 'checked'
    } else {
      return 'unchecked'
    }
  }

  render() {
    return (
      <div className='checkbox'>
        <label>
          <input
            type='checkbox'
            value={this.props.theme.id}
            checked={this.checked()}
            onChange={this.handleChange.bind(this)}
          />
          <span className='cr'>
            <i className='cr-icon fa fa-check' />
          </span>
          <span className={`${this.labelClass()}`}>
            { this.props.theme.name }
          </span>
        </label>
      </div>
    )
  }
}
